import { ActionCreator } from "./../types/store-types";
import {
    AddOptionSuccessActionType,
    DeleteOptionSuccessActionType,
    SelectableOptionsActionTypes,
    AddOptionFailureActionType,
    AddOptionRequestActionType,
    DeleteOptionRequestActionType,
    DeleteOptionFailureActionType,
    UpdateOptionRequestActionType,
    UpdateOptionFailureActionType,
    InitOptionsActionType,
    InitialOptionsActionType,
    UpdateOptionActionType,
    DeleteBulkOptionRequestActionType,
    DeleteBulkOptionSuccessActionType,
    DeleteBulkOptionFailureActionType,
    AddBulkOptionRequestActionType,
    AddBulkOptionSuccessActionType,
    AddBulkOptionFailureActionType,
    SwitchOptionsActionType,
    DuplicateOptionsActionType,
    DuplicateFieldOptionsActionType,
} from "./types";

export const initalOptions: ActionCreator<InitialOptionsActionType> = payload => ({
    type: SelectableOptionsActionTypes.INITIAL_OPTIONS,
    payload,
});

export const initOptions: ActionCreator<InitOptionsActionType> = payload => ({
    type: SelectableOptionsActionTypes.INIT_OPTIONS,
    payload,
});

export const addOptionRequest: ActionCreator<AddOptionRequestActionType> = payload => ({
    type: SelectableOptionsActionTypes.ADD_OPTION_REQUEST,
    payload,
});
export const addOptionSuccess: ActionCreator<AddOptionSuccessActionType> = payload => ({
    type: SelectableOptionsActionTypes.ADD_OPTION_SUCCESS,
    payload,
});
export const addOptionFailure: ActionCreator<AddOptionFailureActionType> = payload => ({
    type: SelectableOptionsActionTypes.ADD_OPTION_FAILURE,
    payload,
});

export const addBulkOptionsRequest: ActionCreator<AddBulkOptionRequestActionType> = payload => ({
    type: SelectableOptionsActionTypes.ADD_BULK_OPTION_REQUEST,
    payload,
});

export const addBulkOptionsSuccess: ActionCreator<AddBulkOptionSuccessActionType> = payload => ({
    type: SelectableOptionsActionTypes.ADD_BULK_OPTION_SUCCESS,
    payload,
});

export const addBulkOptionsFailure: ActionCreator<AddBulkOptionFailureActionType> = payload => ({
    type: SelectableOptionsActionTypes.ADD_BULK_OPTION_FAILURE,
    payload,
});

export const deleteOptionRequest: ActionCreator<DeleteOptionRequestActionType> = payload => ({
    type: SelectableOptionsActionTypes.DELETE_OPTION_REQUEST,
    payload,
});
export const deleteOptionSuccess: ActionCreator<DeleteOptionSuccessActionType> = payload => ({
    type: SelectableOptionsActionTypes.DELETE_OPTION_SUCCESS,
    payload,
});
export const deleteOptionFailure: ActionCreator<DeleteOptionFailureActionType> = payload => ({
    type: SelectableOptionsActionTypes.DELETE_OPTION_FAILURE,
    payload,
});

export const deleteBulkOptionsRequest: ActionCreator<DeleteBulkOptionRequestActionType> = payload => ({
    type: SelectableOptionsActionTypes.DELETE_BULK_OPTION_REQUEST,
    payload,
});
export const deleteBulkOptionsSuccess: ActionCreator<DeleteBulkOptionSuccessActionType> = payload => ({
    type: SelectableOptionsActionTypes.DELETE_BULK_OPTION_SUCCESS,
    payload,
});
export const deleteBulkOptionsFailure: ActionCreator<DeleteBulkOptionFailureActionType> = payload => ({
    type: SelectableOptionsActionTypes.DELETE_BULK_OPTION_FAILURE,
    payload,
});

export const updateOptionRequest: ActionCreator<UpdateOptionRequestActionType> = payload => ({
    type: SelectableOptionsActionTypes.UPDATE_OPTION_REQUEST,
    payload,
});
export const updateOption: ActionCreator<UpdateOptionActionType> = payload => ({
    type: SelectableOptionsActionTypes.UPDATE_OPTION,
    payload,
});
export const updateOptionFailure: ActionCreator<UpdateOptionFailureActionType> = payload => ({
    type: SelectableOptionsActionTypes.UPDATE_OPTION_FAILURE,
    payload,
});

export const switchOptions: ActionCreator<SwitchOptionsActionType> = payload => ({
    type: SelectableOptionsActionTypes.SWITCH_OPTIONS,
    payload,
});

export const duplicateOptions: ActionCreator<DuplicateOptionsActionType> = payload => ({
    type: SelectableOptionsActionTypes.DUPLICATE_OPTIONS,
    payload,
});
export const duplicateFieldOptions: ActionCreator<DuplicateFieldOptionsActionType> = payload => ({
    type: SelectableOptionsActionTypes.DUPLICATE_FIELD_OPTIONS,
    payload,
});
